var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 6h-15C2.1 6 1 7.1 1 8.5v15C1 24.9 2.1 26 3.5 26h15c1.4 0 2.5-1.1 2.5-2.5v-15C21 7.1 19.9 6 18.5 6m9.9 2-5.7 3.9v8.2l5.7 3.9c1.1.8 2.6 0 2.6-1.3V9.3C31 8 29.5 7.2 28.4 8"
})));
export default SvgIconVideo;